import { BENEFITS } from '@lib/data/benefits-of-coding'
import { LazyImage } from '@components/common/image'
import { scrollToTop } from '@common/utils'
import DOMPurify from 'isomorphic-dompurify'

const IMAGE_PATH = '/images/benefits-of-coding/benefits/'

const Benefits = () => (
  <div className="relative overflow-hidden mt-16">
    <LazyImage
      path={IMAGE_PATH}
      name="left-shapes"
      className="hidden lg:flex absolute top-0 left-0 z-10"
      alt="Background left shapes"
    />
    <LazyImage
      path={IMAGE_PATH}
      name="right-shapes"
      className="hidden lg:flex absolute top-0 right-0 z-10 w-1/4"
      alt="Background right shapes"
    />
    <div className="relative z-10">
      <div className="mx-auto mt-10 text-center text-4xl px-5 lg:text-5xl font-700 text-grey-900 lg:mt-0">
        Check out the{' '}
        <span className="text-orange">benefits of learning to code</span>
      </div>
      {BENEFITS.map((benefit, index) => {
        return (
          <div
            className="flex flex-col items-center p-8 space-y-10 lg:space-x-10 mx-auto lg:py-16 lg:flex-row lg:space-y-0 lg:max-w-6xl"
            key={benefit.title}
          >
            <div className={`px-10 ${index % 2 != 0 && 'lg:order-1'}`}>
              <LazyImage
                path={IMAGE_PATH}
                alt={benefit.title}
                name={benefit.imageName}
                className="w-108 h-auto"
              />
            </div>
            <div className="max-w-lg">
              <div
                className={`font-600 text-left text-3xl pt-6 ${
                  index % 2 != 0 && 'lg:order-0'
                }`}
              >
                <div className="mx-auto h-1 w-8 mb-1 bg-orange lg:mx-0" />
                <div
                  className="mx-auto text-center lg:text-left lg:mx-0"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(benefit.title),
                  }}
                />
              </div>
              <div className="text-grey-900 text-center text-lg sm:text-xl lg:text-left font-400 pt-6">
                {benefit.text}
              </div>
            </div>
          </div>
        )
      })}
      <div className="flex flex-col items-center text-center font-600 text-3xl px-5 mt-10 text-grey-900 lg:mt-0">
        Want to drive overall development for your child?
        <button
          className="btn btn-orange my-10 py-3 text-xl font-600"
          onClick={scrollToTop}
        >
          Book your free lesson now
        </button>
      </div>
    </div>
  </div>
)

export default Benefits
